"use client";
import React from "react";
import { TradeCard } from "modules/swap-calculator/model/tradeCard";
import TradeListItem from "modules/swap-calculator/components/lists/TradeListItem";
import useEditCardModal from "modules/swap-calculator/hooks/useEditCardModal";
import { useSwapRemoval } from "modules/swap-calculator/stores/useSwapCalculatorStore";

type Props = {
  list: TradeCard[];
};

function TradeList({ list }: Props) {
  // Optimal Zustand selector - only re-renders when removal state changes
  const { removingCards } = useSwapRemoval();
  const { handleRemoveComplete } = useEditCardModal();

  return (
    <div className="flex flex-1 basis-[49%] flex-col gap-2">
      {list.map((card, index) => (
        <TradeListItem
          key={`${card.name}-${index}`}
          card={card}
          isRemoving={removingCards.has(card.id)}
          onRemoveComplete={() => handleRemoveComplete(card.id)}
        />
      ))}
    </div>
  );
}

export default TradeList;
